import { wrapPageElement as wrap } from './src/components/RootWrapper';

export const wrapPageElement = wrap;
